<template>
    <div data-cy="container_category_list">
        <div class="px-4 pb-2.5" data-cy="container_home_search">
            <InputSearch
                ref="input-search"
                data-cy="input_home_search"
                v-model="searchKeyword"
                :isTextOnly="true"
                :txtPlaceholder="lbl.home.search_placeholder"
                @onEnter="onSearchCampaign()" />
        </div>
        <CatSlider
            v-if="catList.length > 0"
            data-cy="container_cat_slider"
            :catList="catList"
            :defaultIndex="0"
            @clickTab="onSelectCat($event)"
        ></CatSlider>
        <div class="mt-2.5 px-4" data-cy="container_campaign_list">
            <CampaignList
                    ref="campaign-list"
                    data-cy="list_campaign"
                    v-if="campaignListConfig != null && campaignListFilter != null"
                    :initListConfig="campaignListConfig"
                    :initFilterConfig="campaignListFilter"
                    @onLoaded="onLoadCampaign()"
            ></CampaignList>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//component
import InputSearch from '../SearchInput/InputSearch.vue';
import CatSlider from './CatSlider.vue';
import CampaignList from '../CampaignList/CampaignList.vue';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';
import ModalMixin from '@/mixin/ModalMixin';
//service
import BzbsCategory from '@/core/Campaign/service/BzbsCategory.js';
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";

export default {
    name: 'CategorySearchList',
    inject: ["SearchStore"],
    mixins: [LocaleMixin, ModalMixin],
    components: {
        InputSearch,
        CatSlider,
        CampaignList,
    },
    props: {
        categoryConfig:  { type: Object, required: true },
    },
    data: function() {
        return {
            catList: [],
            selectedCat: null,
            searchKeyword: null,

            campaignListConfig: null,
            campaignListFilter: null,
        };
    },
    created: function() {
        this.initList();
    },
    methods: {
        initList: async function() {
            await this.getCategory();

            let catIdParams = this.$route.params.catId;
            if (!Util.isEmptyStr(catIdParams)) {
                let cat = this.catList.find((item) => item.id == catIdParams);
                this.selectedCat = cat != null ? cat : this.catList[0];
            } else {
                this.selectedCat = this.catList[0];
            }

            if (this.selectedCat != null) {
                this.setCampaignList();
            }
        },
        getCategory: function() {
            return new Promise((resolve) => {
                var categoryParam = this.categoryConfig.getParams();

                BzbsCategory.apiGetCategory(categoryParam).subscribe({
                    next: (categories) => {
                        this.catList = categories;
                        console.log('this.catList', this.catList)
                        resolve();
                    },
                    error: (err) => {
                        resolve();
                        this.errorApi(err);
                    },
                });
            });
        },
        setCampaignList: function() {
            this.campaignListConfig = null;
            this.campaignListFilter = null;

            let listConfig = new CampaignListConfigBuilder()
                            .setConfigList(this.selectedCat.listConfig)
                            .setTop(25);
            if (this.selectedCat.id) {
                listConfig.setCatId(this.selectedCat.id);
            }

            this.campaignListConfig = listConfig.create();

            let filterConfig = new CampaignListFilterConfigBuilder();
            this.campaignListFilter = filterConfig.create();
        },
        loadMore: function() {
            this.$refs['campaign-list'].loadMore();
        },
        onSelectCat: function(data) {
            console.log('data', data)
            this.selectedCat = data.cat;

            //tracking
            let label = data.cat.id;
            if(data.cat.mode == 'all'){
                label = 'cat_all';
            }
            this.tracking.event('home_reward', 'click_category', label, null);

            this.setCampaignList();
            this.$refs['campaign-list'].reinitList(this.campaignListConfig, this.campaignListFilter);
        },
        onSearchCampaign: function() {
            console.log('keyword', this.searchKeyword);

            this.tracking.event('home_search', 'click_search', null, null);
            this.SearchStore.methods.onSearch(this.searchKeyword);
            this.$router.push('/search');
            // this.setCampaignList();
            // this.$refs['campaign-list'].reinitList(this.campaignListConfig, this.campaignListFilter);
        },
        onLoadCampaign: function(){
            this.$emit('onLoaded');
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
